import React from "react";
import "./LicencaSuspensa.css";

export const REGULARIZAR_URL = "https://login.newcortex.site/inicio";

export default function LicencaSuspensa() {
  return (
    <section className="licenca-suspensa" aria-labelledby="licenca-suspensa-titulo">
      <div className="licenca-suspensa__faixa" role="alert">
        <span>Licença suspensa por falta de pagamento. Consultas e exportações estão bloqueadas.</span>
        <a href={REGULARIZAR_URL}>Regularizar →</a>
      </div>
      <div className="licenca-suspensa__centro">
        <div className="licenca-suspensa__caixa">
          <div className="licenca-suspensa__cadeado" aria-hidden="true">🔒</div>
          <h2 id="licenca-suspensa-titulo">Licença suspensa</h2>
          <p>Seu acesso continua, mas nada pode ser consultado, exportado ou alterado até o pagamento ser confirmado.</p>
          <a className="licenca-suspensa__botao" href={REGULARIZAR_URL}>
            Regularizar pagamento
          </a>
          <ul>
            <li>Leva para login.newcortex.site/inicio, onde a fatura é paga.</li>
            <li>Confirmado o pagamento, o DadosPJ volta sozinho, sem sair e entrar de novo.</li>
          </ul>
        </div>
      </div>
    </section>
  );
}
